// Lightweight inline-SVG flourishes — the photo substitute. Delicate, on-brand,
// effectively free in performance. Use as header accents and section dividers.

export function Sprig({ size = 22, color = '#C4826A' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
      <path d="M16 29V7" stroke={color} strokeWidth="1.1" strokeLinecap="round" />
      <path d="M16 15c-6-1-8-5-7.5-9C13 6 16 10 16 15Z" fill={color} fillOpacity="0.16" stroke={color} strokeWidth="1" strokeLinejoin="round" />
      <path d="M16 20c6-1 8-5 7.5-9C19 11 16 15 16 20Z" fill={color} fillOpacity="0.16" stroke={color} strokeWidth="1" strokeLinejoin="round" />
      <circle cx="16" cy="6" r="1.7" fill={color} />
    </svg>
  )
}

// A delicate centered divider: line — motif — line
export function Divider({ color = '#C4826A', maxWidth = 160, style }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.6rem', maxWidth, margin: '0 auto', ...style }}>
      <span style={{ flex: 1, height: 1, background: `linear-gradient(to right, transparent, ${color}55)` }} />
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
        <path d="M7 1.5 8.4 5.6 12.5 7 8.4 8.4 7 12.5 5.6 8.4 1.5 7 5.6 5.6Z" fill={color} fillOpacity="0.7" />
      </svg>
      <span style={{ flex: 1, height: 1, background: `linear-gradient(to left, transparent, ${color}55)` }} />
    </div>
  )
}

// A pair of tiny rings — for registry / vows / save-the-date accents
export function Rings({ size = 22, color = '#C9A84C' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
      <circle cx="12.5" cy="19" r="7" stroke={color} strokeWidth="1.4" />
      <circle cx="19.5" cy="19" r="7" stroke={color} strokeWidth="1.4" />
      <path d="M16 9l1.6 2.6h-3.2L16 9Z" fill={color} />
    </svg>
  )
}
